import { Inject, Injectable } from '@angular/core';
import { ModelAdapter } from '@challenger/care/models/model-adapter.interface';

import { LIB_CONFIG } from '@challenger/care/lib-config';
import { LibConfig } from '@challenger/care/models/lib-config.model';

export class CustomHeaderModel {
  public headerText: string;
  public headerContent: string;
  public logoHref: string;
  public logoAlt: string;
  public logoSrc: string;
  public logoAlternativeText: string;
  public backgroundSmallUrl: string;
  public backgroundMediumUrl: string;
  public backgroundLargeUrl: string;
  public usps: UspModel[];
}

export class UspModel {
  constructor(public copy: string, public imageUrl: string) {}
}

@Injectable({
  providedIn: 'root',
})
export class CustomHeaderAdapter implements ModelAdapter<CustomHeaderModel> {
  constructor(@Inject(LIB_CONFIG) private config: LibConfig) {}
  adapt(item): CustomHeaderModel {
    return Object.assign(new CustomHeaderModel(), {
      headerText: item.HeaderText,
      headerContent: item.HeaderContent,
      logoHref: item.logo?.URL,
      logoAlt: item.logo?.alt,
      logoSrc: `${this.config.strapiURL}${item.logo?.media[0]?.url}`,
      logoAlternativeText: item.logo?.media[0]?.alternativeText,
      backgroundSmallUrl: `${this.config.strapiURL}${item.headerMedia[0]?.fixed[0].small.url}`,
      backgroundMediumUrl: `${this.config.strapiURL}${item.headerMedia[0]?.fixed[0].medium.url}`,
      backgroundLargeUrl: `${this.config.strapiURL}${item.headerMedia[0]?.fixed[0].large.url}`,
      usps: item.usp.map((usp) => new UspModel(usp?.copy, `${this.config.strapiURL}${usp?.media[0]?.url}`)),
    });
  }
}
